import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'

const PROFILE_PREFIX = 'cabinet:cars'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const CREATE_CAR_VIEW_NAME = p('create-view')
export const CAR_CATALOG_VIEW_NAME = p('catalog-view')
export const CAR_DETAILS_VIEW_NAME = p('details-view')

const CreateCarView = () => import('./views/CreateCar.vue')
const CarCatalogView = () => import('./views/CatalogOfCars.vue')
const CarDetailsView = () => import('./views/DetailsOfCar.vue')

const BASE_MODEL_NAME = 'cars/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      'create/',
      CreateCarView,
      CREATE_CAR_VIEW_NAME, //cabinet/cars/create-view
      {
        meta: {
          title: () => $t('Створення автомобіля'),
        },
    }),
    route(
      'catalog/',
      CarCatalogView,
      CAR_CATALOG_VIEW_NAME, //cabinet/cars/catalog
      {
        meta: {
          title: () => $t('Усі автомобілі'),
        },
    }),
    route(
      'details/:id/',
      CarDetailsView,
      CAR_DETAILS_VIEW_NAME, //cabinet/cars/details/{id}/
      {
        meta: {
          title: () => $t('Автомобіль дилера'),
          fallbackRouteName: CAR_CATALOG_VIEW_NAME,
        },
    }),
  ]
}

export { BASE_MODEL_NAME }